import { AccountInfo } from "@azure/msal-browser";
import { useAccount, useMsal } from "@azure/msal-react";
import Link from "@mui/material/Link";
import { makeStyles } from "@mui/styles";
import Routes from "./Routes";

const useStyles = makeStyles({
  link: {
    color: "#474747 !important",
    display: "inline-block",
    textAlign: "center",
    margin: "0 15px 0 0 !important",
    textDecoration: "none !important",
    "&:hover": { cursor: "pointer" },
    "&.t-logout": {
      fontSize: "24px  !important",
    },
  },
  label: {
    fontSize: "12px  !important",
  },
});

const LogoutButton = () => {
  const classes = useStyles();
  const { instance } = useMsal();

  // To have a silent logout MS Entra needs to set a "login_hint" on the token claims. For details about this
  // see https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/logout.md#option-2-manually-set-the-logouthint-option-in-the-logout-request
  const accountInfo: AccountInfo | null = useAccount();
  const logoutHint = accountInfo?.idTokenClaims?.login_hint;

  return (
    <Link
      className={classes.link}
      onClick={() =>
        instance.logoutRedirect({ account: accountInfo, postLogoutRedirectUri: window.location.origin + Routes.logout, logoutHint: logoutHint })
      }
    >
      <div className="t-logout"></div>
      <div className={classes.label}>Logout</div>
    </Link>
  );
};

export default LogoutButton;
